import { createAction, props } from '@ngrx/store';

export const OpenSnackbar = createAction(
  '[Shared: Notification]: Open Snackbar',
  props<{
    message: string;
    panelClass: string;
    /** Optional secondary line shown below the message (e.g. "Member: John Doe • Card: #0012345") */
    details?: string;
    /** Optional Material icon name override (e.g. 'add_card', 'credit_card_off') */
    icon?: string;
    /** Optional value to expose a copy-to-clipboard button (e.g. the member's QC code) */
    copyValue?: string;
  }>(),
);

export const NotificationReset = createAction('[Shared: Notification]: Notification Reset');
